module.exports = __webpack_public_path__ + "img/maxar_logo_gold.2e228900.png";